import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const identityLoginDocument = /* GraphQL */ `
    mutation IdentityLogin($input: IdentityLoginInput!) {
        identityLogin(input: $input) {
            success
            userId
            message
            errorCode
        }
    }
`;
export const identityLoginMutation = graphql(identityLoginDocument);
